export enum EligibilityReasons {
  ALREADY_SUBSCRIBED = 'ALREADY_SUBSCRIBED',
  PENDING_TRIAL_CONVERSION = 'PENDING_TRIAL_CONVERSION',
  FORBIDDEN = 'FORBIDDEN',
  DOWNGRADE = 'DOWNGRADE',
  NOT_EOS_LINE = 'NOT_EOS_LINE',
  NOT_SPD_LINE = 'NOT_SPD_LINE',
  UPGRADE = 'UPGRADE',
  COLLECTION_BLOCK = 'COLLECTION_BLOCK',
  NOT_SELLABLE = 'NOT_SELLABLE',
  AFTER_TRIAL = 'AFTER_TRIAL',
  RESUME_AFTER_TRIAL = 'RESUME_AFTER_TRIAL',
  OPTION_FOR = 'OPTION_FOR',
  OPTION_NA = 'OPTION_NA',
  HAS_DAYPASS = 'HAS_DAY_PASS'
}
